import React, { useEffect } from "react";
import LandingTemplate from "../../Templetes/Landing/Landing.template";

const LandingPage = () => {
  useEffect(() => {
    document.title = "Code Champ 2026 — Arab World's #1 Coding & AI Championship";
  }, []);
  return <LandingTemplate />;
};

export default LandingPage;
